// Entry point for the HumOS Canvas application
import { InfiniteCanvas } from './src/InfiniteCanvasSimple.js';
import './src/design/tokens.css';
import './src/design/primitives.css';
import './style.css';
import { applyDesignTokens } from './src/design/tokens.js';

// Initialize the application when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    applyDesignTokens();
    window.canvasApp = new InfiniteCanvas('canvas');
    console.log('HumOS Canvas initialized with modular structure');
});